import React, { useMemo, useState } from "react";
import Layout from "../../Shared/Layout";
import {
    Grid,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
} from "@material-ui/core";
import styled from "styled-components";
import { Inertia } from "@inertiajs/inertia";
import MuiButton from "@material-ui/core/Button";
import FormField from "../../Shared/FormField";
import { Field, Form as FinalForm } from "react-final-form";
import TextInput from "../../Shared/TextInput";
import Select from "../../Shared/Select";
import { getCookieValue } from "../../utils/getCookieValue";
import { Trans } from "../../utils/i18n";
import { resolveClientConfig } from "../../utils/resolveClientConfig";
import DateTimepicker from "../../Shared/DateTimepicker";
import Wrapper from "./Wrapper";
import { InertiaLink } from "@inertiajs/inertia-react";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button } from "@mui/material";
import { FormState } from "../../FormComponents/FormState";
import {Alert} from "@material-ui/lab";

const HR = styled.hr`
    display: flex;
    justify-content: flex-end;
    margin: 15px 0;
`;

const ResponseWrapper = styled.div`
    width: 100%;
    margin-top: 30px;
`;

const createConditionFilter = (values, state) => (fieldOrGroup, step) => {
    if (!fieldOrGroup.condition) {
        return true;
    }

    const paths = fieldOrGroup.condition.field
        .replace(/\[(.*)\]/gm, ".$1")
        .split(".");

    let value = paths.reduce((values, path) => values[path], values);

    if (fieldOrGroup.condition.compare === "!=") {
        if (value === undefined) {
            return null !== fieldOrGroup.condition.value;
        }
        return value !== fieldOrGroup.condition.value;
    }

    return value === fieldOrGroup.condition.value;
};

export default function JobInformation({
    client,
    order,
    statuses,
    services,
    partners,
    coverages,
    settlements,
    materialOperations,
    userCanUpdate,
    orderattributes,
    orderhistories,
    extendedMode,
    permissions,
    returnUrl,
    cancelSecret,
    exceptionTextOptions,
    payment,
    userSrtCreatePermission,
}) {
    const [formState, setFormState] = useState(undefined);
    const [response, setResponse] = useState(undefined);

    const onSubmit = async (data) => {
        setFormState("loading");
        await fetch(route("queue.store"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-XSRF-TOKEN": getCookieValue("XSRF-TOKEN"),
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
                ...data,
                returnUrl,
            }),
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.success) {
                    setFormState("success");
                    setResponse("");
                    Inertia.visit(
                        returnUrl ||
                            route("queue.index", {
                                requesttype: order.requesttype_key,
                            })
                    );
                    return;
                }
                setResponse(response);
                setFormState("error");
            })
            .catch(() => {
                setFormState("error");
            });
    };

    const onAdminOrderCancel = async () => {
        Inertia.post(route("order.adminCancel"), {
            secret: cancelSecret,
        },
        {preserveState: false});
    };

    return (
        <FormState>
            <Wrapper>
                <FinalForm initialValues={order} onSubmit={onSubmit}>
                    {({
                        handleSubmit,
                        submitting,
                        values,
                        form,
                        errors,
                        touched,
                    }) => {
                        const currentStatus = statuses.find(
                            (item) => item.id == values.status_id
                        );
                        const currentService = services.find(
                            (item) => item.id == values.service_id
                        );
                        const currentSettlement = settlements.find(
                            (item) => item.id == values.settlement_id
                        );
                        const conditionFilter = useMemo(
                            () => createConditionFilter(values),
                            [values]
                        );
                        let preFix = "";

                        return (
                            <form onSubmit={handleSubmit}>
                                {extendedMode && (
                                    <div>
                                        <h3>
                                            <Trans i18nKey="queueDetail.jobReferences">
                                                Job references
                                            </Trans>
                                        </h3>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    name={"number"}
                                                    type={"text"}
                                                    component={TextInput}
                                                    field={{
                                                        label: (
                                                            <Trans i18nKey="queueDetail.number">
                                                                Number
                                                            </Trans>
                                                        ),
                                                        type: "text",
                                                    }}
                                                    disabled={
                                                        submitting ||
                                                        !userCanUpdate ||
                                                        !order.permissions.order
                                                            .editNumber
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    name={"b2x_jobnumber"}
                                                    type={"text"}
                                                    component={TextInput}
                                                    field={{
                                                        label: (
                                                            <Trans i18nKey="queueDetail.b2x_jobnumber">
                                                                B2X Job Number
                                                            </Trans>
                                                        ),
                                                        type: "text",
                                                    }}
                                                    disabled={
                                                        submitting ||
                                                        !userCanUpdate ||
                                                        !order.permissions.order
                                                            .editNumber
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    name={"customer_reference"}
                                                    type={"text"}
                                                    component={TextInput}
                                                    field={{
                                                        label: (
                                                            <Trans i18nKey="queueDetail.customer_reference">
                                                                Customer Reference
                                                            </Trans>
                                                        ),
                                                        type: "text",
                                                    }}
                                                    disabled={
                                                        submitting ||
                                                        !userCanUpdate ||
                                                        !order.permissions.order
                                                            .editCustomerReference
                                                    }
                                                />
                                            </Grid>
                                            {values.created_by && (
                                                <Grid item xs={12} sm={6}>
                                                    <Field
                                                        name={"created_by"}
                                                        type={"text"}
                                                        component={TextInput}
                                                        field={{
                                                            label: (
                                                                <Trans i18nKey="queueDetail.created_by">
                                                                    Created by
                                                                </Trans>
                                                            ),
                                                            type: "text",
                                                        }}
                                                        disabled={true}
                                                    />
                                                </Grid>
                                            )}
                                            {values.batch_reference && (
                                                <Grid item xs={12} sm={6}>
                                                    <Field
                                                        name={"batch_reference"}
                                                        type={"text"}
                                                        component={TextInput}
                                                        field={{
                                                            label: (
                                                                <Trans i18nKey="queueDetail.batch_reference">
                                                                    Order Reference
                                                                </Trans>
                                                            ),
                                                            type: "text",
                                                        }}
                                                        disabled={
                                                            submitting ||
                                                            !userCanUpdate ||
                                                            !order.permissions.order
                                                                .editNumber
                                                        }
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                        <HR />
                                    </div>
                                )}

                                {extendedMode && (
                                    <div>
                                        <h3>
                                            <Trans i18nKey="queueDetail.status">
                                                Status
                                            </Trans>
                                        </h3>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={6}>
                                                <div style={{ marginTop: 15 }}>
                                                    <Field
                                                        name={"status_id"}
                                                        type={"select"}
                                                        // placeholder={field.placeholder}
                                                        component={Select}
                                                        // validate={field.required ? validate[field.type] || required : undefined}
                                                        field={{
                                                            disableUnselected: true,
                                                            type: "select",
                                                            label: (
                                                                <Trans i18nKey="queueDetail.status">
                                                                    Status
                                                                </Trans>
                                                            ),
                                                            options: statuses.map(
                                                                (item) => ({
                                                                    value: item.id,
                                                                    label: item.name,
                                                                })
                                                            ),
                                                        }}
                                                        disabled={
                                                            submitting ||
                                                            !userCanUpdate
                                                        }
                                                    />
                                                </div>
                                                <div style={{ marginTop: 15 }} />
                                                {currentStatus &&
                                                    (currentStatus.key ===
                                                        "appointment" ||
                                                        currentStatus.key ===
                                                            "pickup-arrangement" ||
                                                            currentStatus.key ===
                                                                "rescheduled") && (
                                                        <Field
                                                            name={
                                                                "appointment_date"
                                                            }
                                                            // placeholder={field.placeholder}
                                                            component={
                                                                DateTimepicker
                                                            }
                                                            // validate={field.required ? validate[field.type] || required : undefined}
                                                            field={{
                                                                label: (
                                                                    <Trans i18nKey="queueDetail.appointmentDate">
                                                                        Appointment
                                                                        date
                                                                    </Trans>
                                                                ),
                                                                type: "text",
                                                                allowPast: true,
                                                            }}
                                                            disabled={
                                                                submitting ||
                                                                !userCanUpdate
                                                            }
                                                        />
                                                    )}
                                                {currentStatus &&
                                                    currentStatus.key ===
                                                        "shipped" && (
                                                        <Field
                                                            name={"trackingcode"}
                                                            component={TextInput}
                                                            field={{
                                                                label: (
                                                                    <Trans i18nKey="queueDetail.trackingcode">
                                                                        Tracking Code
                                                                    </Trans>
                                                                ),
                                                                type: "text",
                                                            }}
                                                            disabled={
                                                                submitting ||
                                                                !userCanUpdate
                                                            }
                                                        />
                                                    )}
                                                {currentStatus &&
                                                    currentStatus.key ===
                                                        "returnlabel" && (
                                                        <Field
                                                            name={"returnlabel_trackingcode"}
                                                            component={TextInput}
                                                            field={{
                                                                label: (
                                                                    <Trans i18nKey="queueDetail.trackingcode">
                                                                        Tracking Code
                                                                    </Trans>
                                                                ),
                                                                type: "text",
                                                            }}
                                                            disabled={
                                                                submitting ||
                                                                !userCanUpdate
                                                            }
                                                        />
                                                    )}
                                                {currentStatus &&
                                                    currentStatus.key ===
                                                        "diagnose" && (
                                                        <Field
                                                            name={"settlement_id"}
                                                            type={"select"}
                                                            // placeholder={field.placeholder}
                                                            component={Select}
                                                            // validate={field.required ? validate[field.type] || required : undefined}
                                                            field={{
                                                                type: "select",
                                                                label: (
                                                                    <Trans i18nKey="queueDetail.settlement">
                                                                        Settlement
                                                                    </Trans>
                                                                ),
                                                                options:
                                                                    settlements.map(
                                                                        (item) => ({
                                                                            value: item.id,
                                                                            label: item.name,
                                                                        })
                                                                    ),
                                                            }}
                                                            disabled={
                                                                submitting ||
                                                                !userCanUpdate
                                                            }
                                                        />
                                                    )}
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <div style={{ marginTop: 15 }}>
                                                    {
                                                        (!exceptionTextOptions || !Array.isArray(exceptionTextOptions)) &&
                                                        <Field
                                                            name={"status_exception"}
                                                            type={"text"}
                                                            // placeholder={field.placeholder}
                                                            component={TextInput}
                                                            // validate={field.required ? validate[field.type] || required : undefined}
                                                            field={{
                                                                label: (
                                                                    <Trans i18nKey="queueDetail.exceptionText">
                                                                        Exception text
                                                                    </Trans>
                                                                ),
                                                                type: "text",
                                                            }}
                                                            disabled={
                                                                submitting ||
                                                                !userCanUpdate
                                                            }
                                                        />
                                                    }
                                                    {
                                                        (exceptionTextOptions && Array.isArray(exceptionTextOptions)) &&
                                                        <Field
                                                            name={"status_exception"}
                                                            type={"select"}
                                                            component={Select}
                                                            field={{
                                                                type: "select",
                                                                label: (
                                                                    <Trans i18nKey="queueDetail.exceptionText">
                                                                        Exception text
                                                                    </Trans>
                                                                ),
                                                                options: exceptionTextOptions.map(
                                                                    (item) => ({
                                                                        value: item,
                                                                        label: item,
                                                                    })
                                                                ),
                                                            }}
                                                            disabled={
                                                                submitting || !userCanUpdate
                                                            }
                                                        />
                                                    }
                                                </div>
                                                <div style={{ marginTop: 15 }} />
                                                {currentStatus &&
                                                    currentStatus.key ===
                                                        "diagnose" &&
                                                    currentSettlement &&
                                                    currentSettlement.name ===
                                                        "Repair" && (
                                                        <Field
                                                            name={
                                                                "materialOperations_id"
                                                            }
                                                            type={"select"}
                                                            // placeholder={field.placeholder}
                                                            component={Select}
                                                            // validate={field.required ? validate[field.type] || required : undefined}
                                                            field={{
                                                                type: "select",
                                                                label: (
                                                                    <Trans i18nKey="queueDetail.materialOperations">
                                                                        Operations
                                                                    </Trans>
                                                                ),
                                                                options:
                                                                    materialOperations.map(
                                                                        (item) => ({
                                                                            value: item.id,
                                                                            label: item.description,
                                                                        })
                                                                    ),
                                                            }}
                                                            disabled={
                                                                submitting ||
                                                                !userCanUpdate
                                                            }
                                                        />
                                                    )}
                                            </Grid>
                                        </Grid>
                                        <HR />
                                    </div>
                                )}
                                {extendedMode && (
                                    <div>
                                        <h3>
                                            <Trans i18nKey="queueDetail.jobType">
                                                Job type
                                            </Trans>
                                        </h3>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    name={"requesttype"}
                                                    type={"text"}
                                                    component={TextInput}
                                                    field={{
                                                        label: (
                                                            <Trans i18nKey="queueDetail.requesttype">
                                                                Request Reference
                                                            </Trans>
                                                        ),
                                                        type: "text",
                                                    }}
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    name={"service_id"}
                                                    type={"select"}
                                                    // placeholder={field.placeholder}
                                                    component={Select}
                                                    // validate={field.required ? validate[field.type] || required : undefined}
                                                    field={{
                                                        type: "select",
                                                        label: (
                                                            <Trans i18nKey="queueDetail.serviceType">
                                                                Service type
                                                            </Trans>
                                                        ),
                                                        options: services.map(
                                                            (item) => ({
                                                                value: item.id,
                                                                label: item.name,
                                                            })
                                                        ),
                                                    }}
                                                    disabled={
                                                        submitting || !userCanUpdate
                                                    }
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <h3>
                                                    <Trans i18nKey="queueDetail.partner">
                                                        Partner
                                                    </Trans>
                                                </h3>
                                                <Field
                                                    name={"partner_id"}
                                                    type={"select"}
                                                    // placeholder={field.placeholder}
                                                    component={Select}
                                                    // validate={field.required ? validate[field.type] || required : undefined}
                                                    field={{
                                                        type: "select",
                                                        label: (
                                                            <Trans i18nKey="queueDetail.partner">
                                                                Partner
                                                            </Trans>
                                                        ),
                                                        options: partners.map(
                                                            (item) => ({
                                                                value: item.id,
                                                                label: item.name,
                                                            })
                                                        ),
                                                    }}
                                                    disabled={
                                                        submitting || !userCanUpdate
                                                    }
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12}>
                                                <h3>
                                                    <Trans i18nKey="queueDetail.notes.label">
                                                        Notes
                                                    </Trans>
                                                </h3>
                                                <Field
                                                    name={"notes"}
                                                    type={"text"}
                                                    component={TextInput}
                                                    field={{
                                                        label: (
                                                            <Trans i18nKey="queueDetail.notes.label">
                                                                Notes
                                                            </Trans>
                                                        ),
                                                        type: "text",
                                                        multiline: true,
                                                    }}
                                                    disabled={
                                                        submitting || !userCanUpdate
                                                    }
                                                />
                                            </Grid>

                                        {extendedMode &&
                                            currentService &&
                                            (currentService.key ===
                                                "iw-self-repair" ||
                                                currentService.key ===
                                                    "oow-self-repair") && (
                                                <Grid
                                                    key={"spareparts"}
                                                    item
                                                    xs={12}
                                                    sm={"full"}
                                                >
                                                    <FormField
                                                        name={"spareparts"}
                                                        type={"metapicker"}
                                                        // placeholder={field.placeholder}
                                                        component={"metapicker"}
                                                        // validate={field.required ? validate[field.type] || required : undefined}
                                                        field={{
                                                            type: "metapicker",
                                                            key: "spareparts",
                                                            name: "spareparts",
                                                            label: (
                                                                <Trans i18nKey="orderEntry.spareparts.label">
                                                                    Spare parts
                                                                </Trans>
                                                            ),
                                                        }}
                                                        disabled={
                                                            submitting ||
                                                            !userCanUpdate
                                                        }
                                                    />
                                                    {/* <FormField disabled={field.disabledFunction ? field.disabledFunction(values) : false} field={field} preFix={preFix} submitting={submitting} values={values} form={form} mutators={form.mutators} requesttypes={[]}/> */}
                                                </Grid>
                                            )}
                                    </Grid>
                                    <HR />
                                    </div>
                                )}

                                {extendedMode && coverages.length > 0 && (
                                    <div>
                                        <h3>
                                            <Trans i18nKey="queueDetail.coverage">
                                                Coverage
                                            </Trans>
                                        </h3>

                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    name={"coverage_id"}
                                                    type={"select"}
                                                    // placeholder={field.placeholder}
                                                    component={Select}
                                                    // validate={field.required ? validate[field.type] || required : undefined}
                                                    field={{
                                                        type: "select",
                                                        label: (
                                                            <Trans i18nKey="queueDetail.coverage">
                                                                Coverage
                                                            </Trans>
                                                        ),
                                                        options: coverages.map(
                                                            (item) => ({
                                                                value: item.id,
                                                                label: item.name,
                                                            })
                                                        ),
                                                    }}
                                                    disabled={submitting}
                                                />
                                            </Grid>
                                        </Grid>
                                        <HR />
                                    </div>
                                )}

                                {resolveClientConfig(client.key) &&
                                    resolveClientConfig(client.key).groups.map(
                                        (group, index) => {
                                            const fields = group.fields.map(
                                                (field, index) => {
                                                    const size =
                                                        resolveClientConfig(
                                                            client.key
                                                        ).sizes[
                                                            field.size
                                                                ? field.size
                                                                : "full"
                                                        ];

                                                    return (
                                                        (field.conditionFunction
                                                            ? field.conditionFunction(
                                                                values,
                                                                {statuses}
                                                            )
                                                            : true) &&
                                                        conditionFilter(field) && (
                                                            <Grid
                                                                key={index}
                                                                item
                                                                xs={12}
                                                                sm={size}
                                                            >
                                                                <FormField
                                                                    disabled={
                                                                        field.disabledFunction
                                                                            ? field.disabledFunction(
                                                                                values
                                                                            )
                                                                            : false
                                                                    }
                                                                    field={field}
                                                                    preFix={preFix}
                                                                    submitting={
                                                                        submitting
                                                                    }
                                                                    values={values}
                                                                    form={form}
                                                                    mutators={
                                                                        form.mutators
                                                                    }
                                                                    requesttypes={[]}
                                                                />
                                                            </Grid>
                                                        )
                                                    );
                                                }
                                            );
                                            return (
                                                (group.conditionFunction
                                                    ? group.conditionFunction(
                                                        values,
                                                        {statuses}
                                                    )
                                                    : true) &&
                                                conditionFilter(group) && (
                                                    <div key={index}>
                                                        <div>
                                                            <div>
                                                                {group.heading && (
                                                                    <h3>
                                                                        {
                                                                            group.heading
                                                                        }
                                                                    </h3>
                                                                )}
                                                                {group.description && (
                                                                    <p>
                                                                        {
                                                                            group.description
                                                                        }
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <Grid container spacing={3}>
                                                            {fields}
                                                        </Grid>
                                                        {resolveClientConfig(
                                                            client.key
                                                        ).groups.length >
                                                            index + 1 && <hr />}
                                                    </div>
                                                )
                                            );
                                        }
                                    )
                                }

                                <HR />

                                {order?.parent_order && (
                                    <>
                                        <h3>
                                            <Trans i18nKey="queueDetail.parentOrder">
                                                Parent order
                                            </Trans>
                                        </h3>
                                        <Button startIcon={<OpenInNewIcon />} LinkComponent={InertiaLink} href={route('queue.details', {order: order?.parent_order?.order_id})}>
                                            <Trans i18nKey="queueDetail.jobDetail">Job Detail</Trans>: {order?.parent_order?.ordernumber}
                                        </Button>
                                    </>
                                )}

                                {order?.orders && order?.orders?.length > 0 && (
                                    <>
                                        <h3>
                                            <Trans i18nKey="queueDetail.childOrders">
                                                Child orders
                                            </Trans>
                                        </h3>

                                        <ul className="space-y-2 list-none p-0 m-0">
                                            {order?.orders?.map(order => (
                                                <li key={order.order_id}>
                                                    <Button startIcon={<OpenInNewIcon />} LinkComponent={InertiaLink} href={route('queue.details', {order: order?.order_id})}>
                                                        <Trans i18nKey="queueDetail.jobDetail">Job Detail</Trans>: {order?.ordernumber}
                                                    </Button>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}

                                {orderattributes.filter(
                                    (item) => item.key !== "configurations"
                                ).length > 0 && (
                                    <div>
                                        <h3>
                                            <Trans i18nKey="queueDetail.orderAttributes">
                                                Order attributes
                                            </Trans>
                                        </h3>

                                        <TableContainer>
                                            <Table
                                                size="small"
                                                aria-label={
                                                    <Trans i18nKey="queueDetail.aDenseTable">
                                                        a dense table
                                                    </Trans>
                                                }
                                            >
                                                <TableBody>
                                                    {orderattributes
                                                        .filter(
                                                            (item) =>
                                                                item.key !==
                                                                "configurations"
                                                        )
                                                        .map((attribute) => (
                                                            <TableRow
                                                                key={attribute.id}
                                                            >
                                                                <TableCell
                                                                    component="th"
                                                                    scope="row"
                                                                >
                                                                    {attribute.key}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {
                                                                        attribute.value
                                                                    }
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <HR />
                                    </div>
                                )}

                                <div className={'flex justify-end gap-3 mt-10'}>
                                    {
                                        userSrtCreatePermission && !order.b2x_jobnumber && currentStatus.key !== 'closed' && currentStatus.key !== 'canceled' &&
                                        <MuiButton
                                            variant="contained"
                                            color={'primary'}
                                            disabled={submitting}
                                            onClick={() => {
                                                Inertia.post(route('queue.orderhistory.resendSrtCreate', { order: order.order_id }))
                                            }}
                                        >
                                            <Trans i18nKey="queueDetail.sendSrtCreate">Send SRT Create</Trans>
                                        </MuiButton>
                                    }
                                    {order.permissions.order.cancel && (
                                        <MuiButton
                                            variant="contained"
                                            color={"primary"}
                                            disabled={
                                                currentStatus.key !== "created" &&
                                                currentStatus.key !== "paid" &&
                                                currentStatus.key !== "ready" &&
                                                currentStatus.key !== "returnlabel" &&
                                                currentStatus.key !== "acknowledge"
                                            }
                                            onClick={onAdminOrderCancel}
                                            type={"button"}
                                            style={{  maxWidth: "245px", textAlign: 'center' }}
                                        >
                                            <Trans i18nKey="queueDetail.cancelAndRefund">
                                                Cancel and Refund
                                            </Trans>
                                        </MuiButton>
                                    )}
                                    {order.permissions.order.cancelWithReason && (
                                        <MuiButton
                                            variant="contained"
                                            color={"primary"}
                                            disabled={
                                                currentStatus.key !== "created" &&
                                                currentStatus.key !== "paid" &&
                                                currentStatus.key !== "ready" &&
                                                currentStatus.key !== "returnlabel" &&
                                                currentStatus.key !== "acknowledge"
                                            }
                                            href={route("order.cancel", {
                                                secret: cancelSecret,
                                            })}
                                            target="_blank"
                                            style={{ maxWidth: "205px", textAlign: 'center' }}
                                        >
                                            <Trans i18nKey="queueDetail.cancelAndRefundWithReason">
                                                Cancel and Refund With Reason
                                            </Trans>
                                        </MuiButton>
                                    )}
                                    {permissions.includes(
                                        "queue_shipping_label"
                                    ) && (
                                        <MuiButton
                                            variant="contained"
                                            color={"primary"}
                                            disabled={
                                                submitting ||
                                                currentStatus.key === "created" ||
                                                currentStatus.key === "closed" ||
                                                currentStatus.key === "canceled"
                                            }
                                            href={route("queue.shippinglabel", {
                                                ordernumber: order.number,
                                            })}
                                            target="_blank"
                                            style={{ maxWidth: "180px", textAlign: 'center' }}
                                        >
                                            <Trans i18nKey="queueDetail.shippingLabelButton">
                                                CREATE SHIPPING LABEL
                                            </Trans>
                                        </MuiButton>
                                    )}
                                    {extendedMode && (
                                        <MuiButton
                                            variant="contained"
                                            disabled={submitting}
                                            onClick={() =>
                                                Inertia.visit(
                                                    route("queue.index", {
                                                        requesttype:
                                                            order.requesttype_key,
                                                    })
                                                )
                                            }
                                        >
                                            <Trans i18nKey="queueDetail.cancel">
                                                Cancel
                                            </Trans>
                                        </MuiButton>
                                    )}
                                    <MuiButton
                                        variant="contained"
                                        color={"secondary"}
                                        disabled={submitting || !userCanUpdate}
                                        type={"submit"}
                                        onClick={() => {
                                            form.change("saveAndCloseJob", false);
                                        }}
                                    >
                                        <Trans i18nKey="queueDetail.save">
                                            Save
                                        </Trans>
                                    </MuiButton>
                                    {extendedMode == false && (
                                        <MuiButton
                                            variant="contained"
                                            color={"secondary"}
                                            disabled={
                                                submitting ||
                                                !userCanUpdate ||
                                                currentStatus.key === "closed"
                                            }
                                            type={"submit"}
                                            onClick={() => {
                                                form.change(
                                                    "saveAndCloseJob",
                                                    true
                                                );
                                            }}
                                        >
                                            <Trans i18nKey="queueDetail.saveAndClose">
                                                Save & close job
                                            </Trans>
                                        </MuiButton>
                                    )}
                                    <br />
                                </div>
                                <ResponseWrapper>
                                    {
                                        response?.message && <Alert severity="warning">{ response?.message }</Alert>
                                    }
                                </ResponseWrapper>
                            </form>
                        );
                    }}
                </FinalForm>
            </Wrapper>
        </FormState>
    );
}

JobInformation.layout = (page) => <Layout children={page} />;
